import React from "react"
import { connect } from "react-redux"
import { MainActions, AuthActions } from "redux-store/models"
import { Tabs } from "antd"
import { RingProgress } from "@ant-design/plots"
import moment from "moment"

const { TabPane } = Tabs

class StatisticheReportMensile extends React.Component {
  componentDidMount() {
    const {
      activeSkinId,
      setActiveSkinId,
      getLatestServiceStatistic,
      getStatistics,
      getAllImages,
    } = this.props

    const skinIdToUse = activeSkinId !== -1 ? activeSkinId : 2
    if (activeSkinId === -1) setActiveSkinId(2)
    const defaultFrom = moment().startOf("month").format("YYYY-MM-DD")
    const defaultTo = moment().format("YYYY-MM-DD")
    getStatistics("service", defaultFrom, defaultTo, null, activeSkinId === -1 ? null : activeSkinId)
    getAllImages("icon")
    getLatestServiceStatistic(skinIdToUse)
  }

  componentDidUpdate(prevProps) {
    const { activeSkinId, getLatestServiceStatistic, getStatistics } = this.props
    const defaultFrom = moment().startOf("month").format("YYYY-MM-DD")
    const defaultTo = moment().format("YYYY-MM-DD")

    if (activeSkinId !== prevProps.activeSkinId && activeSkinId !== -1) {
      getStatistics("service", defaultFrom, defaultTo, null, activeSkinId ?? null)

      getLatestServiceStatistic(activeSkinId)
    }
  }

  render() {
    const { stats } = this.props

    if (!stats) return null

    const totalAll = Object.values(stats).reduce(
      (sum, s) => sum + (s.total_amount || 0),
      0
    )

    const topServices = Object.entries(stats)
      .map(([key, value]) => ({ serviceKey: key, ...value }))
      .sort((a, b) => b.total_amount - a.total_amount)
      .slice(0, 5)

    const colorConfigs = [
      { color: ["#0AD885", "#DEF4ED"] },
      { color: ["#0062FF", "#DDE8F9"] },
      { color: ["#FD7A18", "#F7EAE1"] },
      { color: ["#ED41E0", "#F5E4F6"] },
      { color: ["#FAD337", "#FBF2D1"] },
    ]

    const config = { height: 60, width: 60, autoFit: false, innerRadius: 0.6 }

    return (
      <div className="statistiche-report-mensili">
        <div className="statistiche-ring-chart">
          {topServices.map((service, index) => {
            const percent =
              totalAll > 0 ? (service.total_amount / totalAll) * 100 : 0

            return (
              <Tabs defaultActiveKey="1" key={service.serviceKey}>
                <TabPane
                  tab={
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <div>
                        <div className="ring-chart-details">
                          {service.serviceKey}
                        </div>
                        <div className="ring-chart-percentage">
                          <div className="details-percentage">
                            <span>Percentuale</span>
                            <span>{percent.toFixed(2)}%</span>
                          </div>
                          <RingProgress
                            percent={percent / 100}
                            color={colorConfigs[index % colorConfigs.length].color}
                            {...config}
                          />
                        </div>
                      </div>
                    </div>
                  }
                  key="tab"
                />
              </Tabs>
            )
          })}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  statistiche: state.auth.Statistiche?.total,
  activeSkinId: state.main.activeSkinId,
  stats: state.main.stats,
  images: state.main.images,
})

export default connect(mapStateToProps, { ...MainActions, ...AuthActions })(
  StatisticheReportMensile
)
